<template>
  <v-select
      :label="label"
      color="dark"
      :items="items"
      :model-value="localValue"
      :clearable="clearable"
      @update:model-value="onChange"
      hide-details
      variant="underlined"
  />
</template>

<script>
export default {
  name: 'FAQCategorySelect',

  props: {
    categories: Array,
    clearable: Boolean,
    language: String,
    label: String,
    modelValue: Number,
    showAllCategories: Boolean
  },

  emits: ['update:modelValue'],

  data() {
    return {
      localValue: this.modelValue,
    }
  },

  computed: {
    items() {
      let items = this.categories.map(c => ({
        title: c.localizedAttributes[this.language].name,
        value: c.id
      }));
      items.unshift({
          title: "Bez kategorie",
          value: -1
      });
      if (this.showAllCategories) {
          items.unshift({
              title: "Všechny",
              value: null
          });
      }
      return items;
    },
  },

  methods: {
    onChange(value) {
      this.localValue = value
      this.$emit('update:modelValue', value); // don't touch me
    },
  }
}
</script>
